<template>
  <!--srcviewscompanycomponenttoolsvuehtmlStart-->

  <div id="defaultId1">
    <gui_tabs
      id="cef862"
      class="uJeKUqr"
      activeIndex="clear"
      @changeMenu="changeMenu"
    >
      <gui_tab_item
        id="c4d1dc"
        class="uKD8C77 uozBR8h"
        active_id="menu"
        @input="clickMenu"
        :isDisabel="!config.menu.isActive"
      >
        <template slot="icon">
          <div class="tollbar-con-filter">
            <el-button
              round
              v-if="$route.query.Moudles == 'Trade'"
              class="tollbar-con-filter-btn icon usRlj2Q usRlj2QTrade"
              :disabled="!config.menu.isActive"
              ><i
                class="iconfont tollbar-con-list-item-icon icon-xingzhuangjiehe"
              ></i
              >{{ $t("Toolbar.Filter") }}</el-button
            >

            <el-button
              v-else
              round
              :class="[
                $store.state.app.searchType == 'risk'
                  ? 'icon usRlj2Q usRlj2QRisk'
                  : 'icon usRlj2Q ',
                $route.path.includes('riskScanning') ? 'riskScanningColor' : '',
              ]"
              class="tollbar-con-filter-btn '"
              :disabled="!config.menu.isActive"
              ><i class="iconfont icon-xingzhuangjiehe"></i
              >{{ $t("Toolbar.Filter") }}</el-button
            >
          </div>
        </template>
      </gui_tab_item>
      <!-- filter老版本 -->
      <!--<gui_tab_item
        id="c2da93"
        v-model="activeMenuId"
        :isDisabel="!config.select.isActive"
        v-if="config.filter.isActive && $store.state.app.searchType == 'risk'"
        class="uskVhXw"
        key="all"
        :style="{ background: $store.state.app.themeColor }"
        active_id="Clear all"
      >
       <div
          id="c6a95a"
          class="u79e9d"
          style="margin-top: -5px"
          v-if="$store.state.app.searchType == 'risk'"
        >
          <span
            id="cb14a2"
            class="select_tab"
            style="color: #fff !important"
            @click="clickAll('ReSelectCriteria')"
            >Reset Filters
          </span>
        </div> 
      </gui_tab_item>-->
      <div id="ccb548" class="u27d59"></div>
      <gui_tab_item
        id="cc254e"
        class="uKD8C77"
        active_id="select"
        v-if="config.select.isShow"
        :isDisabel="!config.select.isActive"
        @input="clickMenu"
      >
        <template slot="icon">
          <i class="iconfont icon-mubiao uupMxrD"></i>
          <i class="iconfont tollbar-con-list-item-icon icon-xuanze"></i>
        </template>

        <div id="c80af0" class="uUgrpts" myData="测试">
          {{ $t("Toolbar.Select") }}
        </div>
      </gui_tab_item>

      <gui_tab_item
        id="c0880e"
        v-model="activeMenuId"
        active_id="edit"
        v-if="config.edit.isShow"
        :isDisabel="!config.edit.isActive"
      >
        <template slot="icon">
          <i
            class="iconfont iconfont tollbar-con-list-item-icon icon-bianji1"
          ></i>
        </template>

        <template>
          <el-dropdown
            id=" c9cc9e"
            class="u994i9a"
            placement="bottom"
            trigger="click"
            :disabled="!config?.edit?.isActive"
          >
            <div id="c4a158" class="el-dropdown-link uOLnMLV">
              <span id="c996c2" class="select_tab u39929 uKD8C77"
                >{{ $t("Toolbar.Edit") }}
              </span>
              <i class="iconfont icon-jiantouxia icon-select"></i>
            </div>
            <div v-show="config.edit.isActive">
              <el-dropdown-menu id="c3b672" slot="dropdown">
                <el-cascader-panel
                  id="c255ed"
                  v-model="cascader6Value"
                  :options="Editoptions"
                  ref="cascader"
                  :filterable="true"
                  :props="{
                    multiple: true,
                    value: 'columnName',
                    label: 'screenName',
                    emitPath: false,
                  }"
                  @change="changeColumn"
                >
                  <template #default="{ node, data }">
                    <span id="c2e092">
                      <span id="caa1e7">{{ data.screenName }} </span>
                    </span>
                    <span id="c5f4d9" v-if="!node.isLeaf">
                      <span id="ceb4bf">({{ data.children.length }}) </span>
                    </span>
                  </template>
                </el-cascader-panel>
              </el-dropdown-menu>
            </div>
          </el-dropdown>
        </template>
      </gui_tab_item>
      <!-- sort -->
      <div
        style="display: flex"
        v-for="(item, index) in queryList"
        @click="powermethod(item)"
        :key="index"
      >
        <div
          style="display: flex"
          v-if="
            item.screenName == $t('Toolbar.Sortby') &&
            item.isShow == true &&
            config.sort.isShow
          "
        >
          <gui_tab_item
            id="c2afd01"
            v-model="activeMenuId"
            class="uKD8C77"
            active_id="sort"
            :isDisabel="!config.sort.isActive || !item.hasPrivilege"
          >
            <template slot="icon">
              <i class="iconfont tollbar-con-list-item-icon icon-filter"></i>
            </template>
            <template>
              <el-dropdown
                id="c4611e"
                class="u994i9a udS8Wxg"
                trigger="click"
                placement="bottom"
                :disabled="!config.sort.isActive"
              >
                <div
                  v-if="item.hasPrivilege"
                  id="cb5823"
                  class="el-dropdown-link u324ce"
                >
                  <span
                    id="c3ca07"
                    class="uUgrpts select_tab unrH9VJ uKD8C77"
                    myData="测试"
                  >
                    {{ $t("Toolbar.Sortby") }}
                  </span>
                  <i class="iconfont icon-jiantouxia icon-select"></i>
                </div>
                <el-popover
                  v-else
                  placement="top-start"
                  width="200"
                  trigger="hover"
                >
                  <div
                    slot="reference"
                    id="c15095"
                    class="uUgrpts"
                    myData="测试"
                  >
                    {{ $t("Toolbar.Sortby") }}
                    <i class="iconfont icon-jiantouxia icon-select"></i>
                  </div>
                </el-popover>
                <div
                  id="c106a6"
                  v-show="item.hasPrivilege"
                  class="u2ed25 u5c5c7"
                >
                  <el-dropdown-menu
                    id="c062ee"
                    class="ujAIBvN"
                    slot="dropdown"
                    v-show="$route.meta.title != 'companyDetails'"
                  >
                    <el-cascader-panel
                      id="cef5b0"
                      v-model="sortList"
                      class="u7PkfAW"
                      :options="sort_listOptions"
                      @change="CheckSort"
                      ref="cascader"
                      :filterable="true"
                      :props="{ multiple: false }"
                    >
                      <template #default="{ node, data }">
                        <span id="c214bd" class="uwfvWhL">
                          <span
                            id="ce9d28"
                            class="uvHkMZZ"
                            v-if="
                              data.label == $t('Toolbar.ascending') ||
                              data.label == $t('Toolbar.descending')
                            "
                            >{{ data.label }}
                          </span>
                          <span id="ce9d28" class="uvHkMZZ" v-else
                            >{{ data.label }}
                          </span>
                        </span>
                        <span id="cbe032" class="uAGF3UD" v-if="!node.isLeaf">
                          <span id="cf3b86" class="utCGg7o"
                            >({{ data.children.length }})
                          </span>
                        </span>
                      </template>
                    </el-cascader-panel>
                  </el-dropdown-menu>
                </div>
              </el-dropdown>
            </template>
          </gui_tab_item>
        </div>
        <!-- Collect -->
        <div
          style="display: flex"
          v-if="
            item.screenName == $t('Toolbar.Collect') &&
            item.isShow == true &&
            config.collect.isShow
          "
        >
          <gui_tab_item
            id="c0b472"
            v-model="activeMenuId"
            active_id="collect"
            :isDisabel="!config.collect.isActive || !item.hasPrivilege"
          >
            <template slot="icon">
              <i class="iconfont tollbar-con-list-item-icon icon-shoucang1"></i>
            </template>
            <template>
              <el-dropdown
                id="cc6c02"
                class="u994i9a"
                trigger="click"
                placement="bottom"
                :disabled="!config?.collect?.isActive || !item.hasPrivilege"
              >
                <!--&& -->
                <div
                  v-if="item.hasPrivilege"
                  id="cacb01"
                  class="el-dropdown-link u324ce"
                >
                  <div
                    id="c42102"
                    class="uUgrpts select_tab unrH9VJ uKD8C77"
                    myData="测试"
                  >
                    {{ $t("Toolbar.Collect") }}
                  </div>
                  <i class="iconfont icon-jiantouxia icon-select"></i>
                </div>
                <el-popover
                  v-else
                  placement="top-start"
                  :disabled="true"
                  width="200"
                  trigger="hover"
                >
                  <div
                    slot="reference"
                    id="c15095"
                    class="uUgrpts uKD8C77"
                    myData="测试"
                  >
                    {{ $t("Toolbar.Collect") }}
                    <i class="iconfont icon-jiantouxia icon-select"></i>
                  </div>
                </el-popover>
                <div>
                  <div id="c2e9fd" v-show="item.hasPrivilege" slot="dropdown">
                    <el-dropdown-menu id="c7c233" class="uWDPJiJ colDropDown">
                      <div v-show="favoritesList.length > 0">
                        <el-checkbox-group
                          v-model="checkList"
                          @change="CollectCheckBook"
                        >
                          <div
                            class="checkBoxHover"
                            v-for="(ite, inde) in favoritesList"
                          >
                            <el-checkbox
                              class="elcheckbook"
                              :key="inde"
                              :label="ite.id"
                            >
                              {{ ite.name }}
                            </el-checkbox>
                          </div>
                        </el-checkbox-group>
                      </div>
                      <div class="CollecInput" v-if="CollectShow">
                        <el-input
                          autocomplete="off"
                          placeholder="Favorite Name"
                          v-model="CollectAdd"
                        >
                          <el-button slot="append" @click="AddCollect"
                            >Confirm</el-button
                          >
                        </el-input>
                      </div>
                      <div
                        class="CollectBottom uKD8C77"
                        @click="CollectShow = true"
                      >
                        <svg
                          t="1725592052707"
                          class="icon"
                          viewBox="0 0 1024 1024"
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                          p-id="6507"
                          width="20"
                          height="20"
                        >
                          <path
                            d="M512 51.2c253.952 0 460.8 206.848 460.8 460.8s-206.848 460.8-460.8 460.8-460.8-206.848-460.8-460.8 206.848-460.8 460.8-460.8m0-51.2C229.376 0 0 229.376 0 512s229.376 512 512 512 512-229.376 512-512S794.624 0 512 0z"
                            fill="#1A2332"
                            p-id="6508"
                          ></path>
                          <path
                            d="M244.736 540.672H773.12c14.336 0 25.6-11.264 25.6-25.6s-11.264-25.6-25.6-25.6H244.736c-14.336 0-25.6 11.264-25.6 25.6s11.776 25.6 25.6 25.6z"
                            fill="#1A2332"
                            p-id="6509"
                          ></path>
                          <path
                            d="M510.976 224.256c-14.336 0-25.6 11.264-25.6 25.6V778.24c0 14.336 11.264 25.6 25.6 25.6s25.6-11.264 25.6-25.6V249.856c0.512-14.336-10.752-25.6-25.6-25.6z"
                            fill="#1A2332"
                            p-id="6510"
                          ></path>
                        </svg>
                        <span style="margin-left: 10px">{{
                          $t("Toolbar.Yourfolder")
                        }}</span>
                      </div>
                    </el-dropdown-menu>
                  </div>
                </div>
              </el-dropdown>
            </template>
          </gui_tab_item>
        </div>

        <!-- Saved -->

        <div
          style="display: flex"
          v-show="
            item.screenName == $t('Toolbar.Saved') &&
            item.isShow == true &&
            config.saved.isShow
          "
        >
          <gui_tab_item
            id="c0b472"
            class="uKD8C77"
            v-model="activeMenuId"
            active_id="saved"
            :isDisabel="!config.saved.isActive || !item.hasPrivilege"
          >
            <template slot="icon">
              <i class="iconfont tollbar-con-list-item-icon icon-baocun"></i>
            </template>
            <template>
              <el-dropdown
                id="cac680"
                class="u994i9a udS8Wxg"
                trigger="click"
                placement="bottom"
                :disabled="!config?.saved?.isActive || !item.hasPrivilege"
              >
                <div
                  id="c68926"
                  v-if="item.hasPrivilege"
                  class="el-dropdown-link u324ce"
                >
                  <div
                    id="c31216"
                    class="uUgrpts select_tab unrH9VJ uKD8C77"
                    myData="测试"
                  >
                    {{ $t("Toolbar.Saved") }}
                  </div>
                  <i class="iconfont icon-jiantouxia icon-select"></i>
                </div>
                <el-popover
                  v-else
                  placement="top-start"
                  :disabled="true"
                  width="200"
                  trigger="hover"
                >
                  <div
                    slot="reference"
                    id="c15095"
                    class="uUgrpts uKD8C77"
                    myData="测试"
                  >
                    {{ $t("Toolbar.Saved") }}
                    <i class="iconfont icon-jiantouxia icon-select"></i>
                  </div>
                </el-popover>
                <div id="c65b56" v-show="item.hasPrivilege" slot="dropdown">
                  <div v-show="favoritesList.length > 0">
                    <el-dropdown-menu id="c30e13" class="uWDPJiJ">
                      <el-dropdown-item
                        id="c5c5cb"
                        v-for="(item, index) in favoritesList"
                        :key="index"
                      >
                        <div @click="ChangeSave(item.id)">
                          <div
                            id="cf870f"
                            @click="activeSavedId = item.id"
                            class="u606de"
                          >
                            <div
                              id="cd7742"
                              :class="activeSavedId == item.id ? 'active' : ''"
                              class="ucc8d2 uKD8C77"
                            >
                              {{ item.name }}
                            </div>
                          </div>
                        </div>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </div>
                </div>
              </el-dropdown>
            </template>
          </gui_tab_item>
        </div>
        <!-- Compare -->
        <div
          style="display: flex"
          v-if="
            item.screenName == $t('Toolbar.Compare') &&
            item.isShow == true &&
            config.compare.isShow
          "
        >
          <gui_tab_item
            id="c11a66"
            v-model="activeMenuId"
            class="uKD8C77"
            active_id="Compare"
            :isDisabel="!config.compare.isActive || !item.hasPrivilege"
            @input="clickMenu"
          >
            <template slot="icon">
              <i
                class="iconfont tollbar-con-list-item-icon icon-icon_xinyong_xianxing_jijin-307"
              ></i>
            </template>
            <template>
              <div
                id="c22c95"
                v-if="item.hasPrivilege"
                class="uUgrpts uKD8C77"
                myData="测试"
              >
                {{ item.screenName }}
              </div>
              <el-popover
                v-else
                placement="top-start"
                :disabled="true"
                width="200"
                trigger="hover"
              >
                <div
                  slot="reference"
                  id="c15095"
                  class="uUgrpts uKD8C77"
                  myData="测试"
                >
                  {{ item.screenName }}
                </div>
              </el-popover>
            </template>
          </gui_tab_item>
        </div>
        <!-- Export -->
        <div
          style="display: flex"
          v-if="
            item.screenName == $t('Toolbar.Export') &&
            item.isShow == true &&
            config.export.isShow
          "
        >
          <gui_tab_item
            id="cabc6b"
            v-model="activeMenuId"
            active_id="Export"
            :isDisabel="!config.export.isActive || !item.hasPrivilege"
            @input="clickMenu"
          >
            <template slot="icon">
              <i class="iconfont tollbar-con-list-item-icon icon-daochu04"></i>
            </template>
            <div></div>
            <div class="uKD8C77" @click="clickExport">
              {{ $t("Toolbar.Export") }}
            </div>
          </gui_tab_item>
        </div>
        <!-- Download -->
        <div
          style="display: flex"
          v-if="
            item.screenName == $t('Toolbar.Download') &&
            item.isShow == true &&
            config.download.isShow
          "
        >
          <gui_tab_item
            id="c9c0e4"
            v-model="activeMenuId"
            active_id="download"
            :isDisabel="!item.hasPrivilege || !config.download.isActive"
            @input="clickMenu"
          >
            <template slot="icon">
              <i class="iconfont tollbar-con-list-item-icon icon-xiazai"></i>
            </template>
            <template>
              <div
                id="c15095"
                v-if="item.hasPrivilege"
                class="uUgrpts uKD8C77"
                myData="测试"
              >
                <el-popover
                  v-if="DownloadStatus == 2"
                  placement="top-start"
                  :disabled="true"
                  width="200"
                  trigger="hover"
                >
                  <div
                    slot="reference"
                    id="c15095"
                    class="uUgrpts uKD8C77"
                    myData="测试"
                  >
                    In production
                  </div>
                </el-popover>
                <div v-else slot="reference" id="c15095" class="uUgrpts">
                  {{ $t("Toolbar.Download") }}
                </div>
              </div>
            </template>
          </gui_tab_item>
        </div>
        <!-- Update -->
        <div
          style="display: flex"
          v-if="
            item.screenName == $t('Toolbar.Update') &&
            item.isShow == true &&
            config.update.isShow
          "
        >
          <el-button
            v-show="updateButtonActive"
            class="btn_update"
            :isDisabel="!config.update.isActive || !item.hasPrivilege"
            @click="clickMenuUpdate"
            ><i
              class="iconfont tollbar-con-list-item-icon icon-shuaxin update-icon"
            ></i
            ><span>{{ $t("Toolbar.Update") }}</span>
          </el-button>
          <gui_tab_item
            v-show="!updateButtonActive"
            id="c40519"
            v-model="activeMenuId"
            class="uKD8C77 svg_update"
            active_id="Update"
            :isDisabel="!config.update.isActive || !item.hasPrivilege"
            @input="clickMenu"
          >
            <template slot="icon">
              <i class="iconfont tollbar-con-list-item-icon icon-shuaxin"></i>
            </template>
            <template>
              <div
                id="c15095"
                v-if="$route.meta.title != 'companyDetails'"
                class="uUgrpts uKD8C77"
                myData="测试"
              >
                {{ $t("Toolbar.Update") }}
              </div>
              <div v-else>
                <div
                  v-if="UpdateStatus == 2 || UpdateStatus == 6"
                  slot="reference"
                  id="c15095"
                  class="uUgrpts"
                  myData="测试"
                >
                  {{ $t("Toolbar.Update") }}
                </div>
                <el-popover
                  popper-class="tool_popover"
                  v-else
                  placement="top-start"
                  width="200"
                  trigger="hover"
                  :disabled="$route.meta.title != 'companyDetails'"
                  :content="
                    UpdateStatus == '3'
                      ? 'The offline report you downloaded is currently being produced.'
                      : 'The offline report you downloaded has been completed. Please download it from the updates ordered screen in your personal center'
                  "
                >
                  <div
                    slot="reference"
                    id="c15095"
                    class="uUgrpts"
                    myData="测试"
                  >
                    {{ UpdateStatus == "3" ? "In production" : "Finished" }}
                  </div>
                </el-popover>
              </div>
            </template>
          </gui_tab_item>
        </div>
        <!-- Report -->
        <div
          style="display: flex"
          v-if="
            item.screenName == $t('Toolbar.Reporterror') &&
            item.isShow == true &&
            config.reportError.isShow
          "
        >
          <gui_tab_item
            id="c6c5f5"
            v-model="activeMenuId"
            active_id="Report"
            :isDisabel="!config.reportError.isActive || !item.hasPrivilege"
            @input="clickMenu"
          >
            <template slot="icon">
              <i class="iconfont tollbar-con-list-item-icon icon-judan"></i>
            </template>
            <div
              id="cdbd3a"
              v-if="item.hasPrivilege"
              class="uKD8C77"
              myData="测试"
            >
              {{ $t("Toolbar.Reporterror") }}
            </div>
            <el-popover
              v-else
              placement="top-start"
              :disabled="true"
              width="200"
              trigger="hover"
            >
              <div
                slot="reference"
                id="c15095"
                class="uUgrpts uKD8C77"
                myData="测试"
              >
                {{ $t("Toolbar.Reporterror") }}
              </div>
            </el-popover>
          </gui_tab_item>
        </div>
        <!-- Risk Scanning -->
        <div
          style="display: flex"
          v-if="
            item.screenName == 'Risk Scanning' &&
            item.isShow == true &&
            config.riskScanning.isShow
          "
        >
          <gui_tab_item
            id="c6c5f5"
            v-model="activeMenuId"
            active_id="riskScanning"
            :isDisabel="!config.riskScanning.isActive || !item.hasPrivilege"
            @input="clickMenu"
          >
            <template slot="icon">
              <i class="iconfont tollbar-con-list-item-icon icon-saomiao"></i>
            </template>
            <div
              id="cdbd3a"
              v-if="item.hasPrivilege"
              class="uKD8C77"
              myData="测试"
            >
              {{ item.screenName }}
            </div>
            <el-popover
              v-else
              placement="top-start"
              :disabled="true"
              width="200"
              trigger="hover"
            >
              <div
                slot="reference"
                id="c15095"
                class="uUgrpts uKD8C77"
                myData="测试"
              >
                {{ item.screenName }}
              </div>
            </el-popover>
          </gui_tab_item>
        </div>
        <!--  Credit Assessment-->
        <div
          style="display: flex"
          v-if="
            item.screenName == 'Credit Assessment' &&
            item.isShow == true &&
            config.creditAssessment.isShow
          "
        >
          <gui_tab_item
            id="c6c5f5"
            v-model="activeMenuId"
            active_id="creditAssessment"
            :isDisabel="!config.creditAssessment.isActive || !item.hasPrivilege"
            @input="clickMenu"
          >
            <template slot="icon">
              <i
                class="iconfont tollbar-con-list-item-icon icon--fuwu-xianxing"
              ></i>
            </template>
            <div
              id="cdbd3a"
              v-if="item.hasPrivilege"
              class="uKD8C77"
              myData="测试"
            >
              {{ item.screenName }}
            </div>
            <el-popover
              v-else
              placement="top-start"
              :disabled="true"
              width="200"
              trigger="hover"
            >
              <div
                slot="reference"
                id="c15095"
                class="uUgrpts uKD8C77"
                myData="测试"
              >
                {{ item.screenName }}
              </div>
            </el-popover>
          </gui_tab_item>
        </div>
        <!-- dataAnalysis -->
        <div
          style="display: flex"
          v-if="
            item.screenName == 'Data Analysis' &&
            item.isShow == true &&
            config.dataAnalysis.isShow
          "
        >
          <gui_tab_item
            id="c6c5f5"
            v-model="activeMenuId"
            active_id="dataAnalysis"
            :isDisabel="!config.dataAnalysis.isActive || !item.hasPrivilege"
            @input="clickMenu"
          >
            <template slot="icon">
              <i
                class="iconfont tollbar-con-list-item-icon icon-shujufenxi1"
              ></i>
            </template>
            <div
              id="cdbd3a"
              v-if="item.hasPrivilege"
              class="uKD8C77"
              myData="测试"
            >
              {{ item.screenName }}
            </div>
            <el-popover
              v-else
              placement="top-start"
              :disabled="true"
              width="200"
              trigger="hover"
            >
              <div
                slot="reference"
                id="c15095"
                class="uUgrpts uKD8C77"
                myData="测试"
              >
                {{ item.screenName }}
              </div>
            </el-popover>
          </gui_tab_item>
        </div>
        <!-- customPortfolio -->
        <div
          style="display: flex"
          v-if="
            item.screenName == 'New Portfolio' &&
            item.isShow == true &&
            config.customPortfolio.isShow
          "
        >
          <gui_tab_item
            id="c6c5f5"
            v-model="activeMenuId"
            active_id="customPortfolio"
            :isDisabel="!config.customPortfolio.isActive || !item.hasPrivilege"
            @input="clickMenu"
          >
            <template slot="icon">
              <i class="iconfont tollbar-con-list-item-icon icon-touzizuhe"></i>
            </template>
            <div
              id="cdbd3a"
              v-if="item.hasPrivilege"
              class="uKD8C77"
              myData="测试"
            >
              {{ item.screenName }}
            </div>
            <el-popover
              v-else
              placement="top-start"
              :disabled="true"
              width="200"
              trigger="hover"
            >
              <div
                slot="reference"
                id="c15095"
                class="uUgrpts uKD8C77"
                myData="测试"
              >
                {{ item.screenName }}
              </div>
            </el-popover>
          </gui_tab_item>
        </div>
        <div
          style="display: flex"
          v-if="
            item.screenName == 'Print' &&
            item.isShow == true &&
            config.print.isShow
          "
        >
          <gui_tab_item
            id="c6c5f5"
            v-model="activeMenuId"
            active_id="print"
            :isDisabel="!config.print.isActive || !item.hasPrivilege"
            @input="clickMenu"
          >
            <template slot="icon">
              <i
                class="iconfont tollbar-con-list-item-icon icon-dayin-dayinji"
              ></i>
            </template>
            <div
              id="cdbd3a"
              v-if="item.hasPrivilege"
              class="uKD8C77"
              myData="测试"
            >
              {{ item.screenName }}
            </div>
            <el-popover
              v-else
              placement="top-start"
              :disabled="true"
              width="200"
              trigger="hover"
            >
              <div
                slot="reference"
                id="c15095"
                class="uUgrpts uKD8C77"
                myData="测试"
              >
                {{ item.screenName }}
              </div>
            </el-popover>
          </gui_tab_item>
        </div>
        <!-- Share -->
        <div
          style="display: flex"
          v-if="
            item.screenName == $t('Toolbar.Share') &&
            item.isShow == true &&
            config.share.isShow
          "
        >
          <gui_tab_item
            id="ccba1d"
            v-model="activeMenuId"
            active_id="Share"
            :isDisabel="!config.share.isActive || !item.hasPrivilege"
            @input="clickMenu"
          >
            <template slot="icon">
              <i class="iconfont tollbar-con-list-item-icon icon-gudong"></i>
            </template>
            <div id="c82736" myData="测试" class="uKD8C77">
              {{ $t("Toolbar.Share") }}
            </div>
          </gui_tab_item>
        </div>
      </div>
      <!-- ... -->
      <gui_tab_item
        id="c22989"
        v-model="activeMenuId"
        class="uSiB38S"
        active_id="more"
      >
        <template slot="icon"> </template>

        <el-dropdown
          id="cac680"
          class="u994i9a"
          trigger="click"
          placement="bottom"
        >
          <div id="c68926" class="el-dropdown-link u324ce">
            <i class="iconfont tollbar-con-list-item-icon icon-gengduo2"></i>
          </div>
          <div id="c65b56" slot="dropdown">
            <el-dropdown-menu id="c30e13" class="uWDPJiJ more_list">
              <div id="gd5a26">
                <!-- Select -->
                <div
                  style="display: flex"
                  class="pb10 pt10 head_more_item"
                  v-if="!config.select.isShow"
                >
                  <gui_tab_item
                    id="c6c5f5"
                    v-model="activeMenuId"
                    active_id="Select"
                    :isDisabel="!config.select.isActive || !item.hasPrivilege"
                    @input="clickMenu"
                  >
                    <template slot="icon">
                      <i class="iconfont icon-mubiao uupMxrD"></i>
                      <i
                        class="iconfont tollbar-con-list-item-icon icon-xuanze"
                      ></i>
                    </template>

                    <div id="c80af0" class="uUgrpts" myData="测试">
                      {{ $t("Toolbar.Select") }}
                    </div>
                  </gui_tab_item>
                </div>
                <!-- edit -->
                <div
                  style="display: flex"
                  class="pb10 pt10 head_more_item"
                  v-if="!config.edit.isShow"
                >
                  <gui_tab_item
                    id="c0880e"
                    v-model="activeMenuId"
                    active_id="edit"
                    v-if="!config.edit.isShow"
                    :isDisabel="!config.edit.isActive"
                  >
                    <template slot="icon">
                      <i
                        class="iconfont iconfont tollbar-con-list-item-icon icon-bianji1"
                      ></i>
                    </template>
                    <div id="c80af0" class="uUgrpts" myData="测试">
                      {{ $t("Toolbar.Edit") }}
                    </div>
                  </gui_tab_item>
                </div>
                <div
                  style="display: flex"
                  v-for="(item, index) in queryList"
                  @click="powermethod(item)"
                  :key="index"
                >
                  <!-- sort -->
                  <div
                    style="display: flex"
                    class="pb10 pt10 head_more_item"
                    v-if="
                      item.screenName == $t('Toolbar.Sortby') &&
                      item.isShow == true &&
                      !config.sort.isShow
                    "
                  >
                    <gui_tab_item
                      id="c2afd01"
                      v-model="activeMenuId"
                      class="uKD8C77"
                      active_id="sort"
                      :isDisabel="!config.sort.isActive || !item.hasPrivilege"
                    >
                      <template slot="icon">
                        <i
                          class="iconfont tollbar-con-list-item-icon icon-filter"
                        ></i>
                      </template>
                      <div
                        id="c31216"
                        class="uUgrpts select_tab unrH9VJ uKD8C77"
                        myData="测试"
                      >
                        {{ $t("Toolbar.Sortby") }}
                      </div>
                    </gui_tab_item>
                  </div>
                  <!-- Collect -->
                  <div
                    style="display: flex"
                    class="pb10 pt10 head_more_item"
                    v-if="
                      item.screenName == $t('Toolbar.Collect') &&
                      item.isShow == true &&
                      !config.collect.isShow
                    "
                  >
                    <gui_tab_item
                      id="c0b472"
                      v-model="activeMenuId"
                      active_id="collect"
                      :isDisabel="
                        !config.collect.isActive || !item.hasPrivilege
                      "
                    >
                      <template slot="icon">
                        <i
                          class="iconfont tollbar-con-list-item-icon icon-shoucang1"
                        ></i>
                      </template>
                      <div
                        id="c42102"
                        class="uUgrpts select_tab unrH9VJ uKD8C77"
                        myData="测试"
                      >
                        {{ $t("Toolbar.Collect") }}
                      </div>
                    </gui_tab_item>
                  </div>

                  <!-- Saved -->

                  <div
                    style="display: flex"
                    class="pb10 pt10 head_more_item"
                    v-if="
                      item.screenName == $t('Toolbar.Saved') &&
                      item.isShow == true &&
                      !config.saved.isShow
                    "
                  >
                    <gui_tab_item
                      id="c0b472"
                      class="uKD8C77"
                      v-model="activeMenuId"
                      active_id="saved"
                      :isDisabel="!config.saved.isActive || !item.hasPrivilege"
                    >
                      <template slot="icon">
                        <i
                          class="iconfont tollbar-con-list-item-icon icon-baocun"
                        ></i>
                      </template>
                      <div
                        id="c31216"
                        class="uUgrpts select_tab unrH9VJ uKD8C77"
                        myData="测试"
                      >
                        {{ $t("Toolbar.Saved") }}
                      </div>
                    </gui_tab_item>
                  </div>
                  <!-- Compare -->
                  <div
                    style="display: flex"
                    class="pb10 pt10 head_more_item"
                    v-if="
                      item.screenName == $t('Toolbar.Compare') &&
                      item.isShow == true &&
                      !config.compare.isShow
                    "
                  >
                    <gui_tab_item
                      id="c11a66"
                      v-model="activeMenuId"
                      class="uKD8C77"
                      active_id="Compare"
                      :isDisabel="
                        !config.compare.isActive || !item.hasPrivilege
                      "
                      @input="clickMenu"
                    >
                      <template slot="icon">
                        <i
                          class="iconfont tollbar-con-list-item-icon icon-icon_xinyong_xianxing_jijin-307"
                        ></i>
                      </template>
                      <template>
                        <div
                          id="c22c95"
                          v-if="item.hasPrivilege"
                          class="uUgrpts uKD8C77"
                          myData="测试"
                        >
                          {{ item.screenName }}
                        </div>
                        <el-popover
                          v-else
                          placement="top-start"
                          :disabled="true"
                          width="200"
                          trigger="hover"
                        >
                          <div
                            slot="reference"
                            id="c15095"
                            class="uUgrpts uKD8C77"
                            myData="测试"
                          >
                            {{ item.screenName }}
                          </div>
                        </el-popover>
                      </template>
                    </gui_tab_item>
                  </div>
                  <!-- Export -->
                  <div
                    style="display: flex"
                    class="pb10 pt10 head_more_item"
                    v-if="
                      item.screenName == $t('Toolbar.Export') &&
                      item.isShow == true &&
                      !config.export.isShow
                    "
                  >
                    <gui_tab_item
                      id="cabc6b"
                      v-model="activeMenuId"
                      active_id="Export"
                      :isDisabel="!config.export.isActive || !item.hasPrivilege"
                      @input="clickMenu"
                    >
                      <template slot="icon">
                        <i
                          class="iconfont tollbar-con-list-item-icon icon-daochu04"
                        ></i>
                      </template>
                      <div></div>
                      <div class="uKD8C77" @click="clickExport">
                        {{ $t("Toolbar.Export") }}
                      </div>
                    </gui_tab_item>
                  </div>
                  <!-- Download -->
                  <div
                    style="display: flex"
                    class="pb10 pt10 head_more_item"
                    v-if="
                      item.screenName == $t('Toolbar.Download') &&
                      item.isShow == true &&
                      !config.download.isShow
                    "
                  >
                    <gui_tab_item
                      id="c9c0e4"
                      v-model="activeMenuId"
                      active_id="download"
                      :isDisabel="
                        !item.hasPrivilege || !config.download.isActive
                      "
                      @input="clickMenu"
                    >
                      <template slot="icon">
                        <i
                          class="iconfont tollbar-con-list-item-icon icon-xiazai"
                        ></i>
                      </template>
                      <template>
                        <div
                          id="c15095"
                          v-if="item.hasPrivilege"
                          class="uUgrpts uKD8C77"
                          myData="测试"
                        >
                          <el-popover
                            v-if="DownloadStatus == 2"
                            placement="top-start"
                            :disabled="true"
                            width="200"
                            trigger="hover"
                          >
                            <div
                              slot="reference"
                              id="c15095"
                              class="uUgrpts uKD8C77"
                              myData="测试"
                            >
                              In production
                            </div>
                          </el-popover>
                          <div
                            v-else
                            slot="reference"
                            id="c15095"
                            class="uUgrpts"
                          >
                            {{ $t("Toolbar.Download") }}
                          </div>
                        </div>
                      </template>
                    </gui_tab_item>
                  </div>
                  <!-- Update -->
                  <div
                    style="display: flex"
                    class="pb10 pt10 head_more_item"
                    v-if="
                      item.screenName == $t('Toolbar.Update') &&
                      item.isShow == true &&
                      !config.update.isShow
                    "
                  >
                    <gui_tab_item
                      id="c40519"
                      v-model="activeMenuId"
                      class="uKD8C77 svg_update"
                      active_id="Update"
                      :isDisabel="!config.update.isActive || !item.hasPrivilege"
                      @input="clickMenu"
                    >
                      <template slot="icon">
                        <i
                          class="iconfont tollbar-con-list-item-icon icon-shuaxin"
                        ></i>
                      </template>
                      <template>
                        <div
                          id="c15095"
                          v-if="$route.meta.title != 'companyDetails'"
                          class="uUgrpts uKD8C77"
                          myData="测试"
                        >
                          {{ $t("Toolbar.Update") }}
                        </div>
                        <div v-else>
                          <div
                            v-if="UpdateStatus == 2 || UpdateStatus == 6"
                            slot="reference"
                            id="c15095"
                            class="uUgrpts"
                            myData="测试"
                          >
                            {{ $t("Toolbar.Update") }}
                          </div>
                          <el-popover
                            popper-class="tool_popover"
                            v-else
                            placement="top-start"
                            width="200"
                            trigger="hover"
                            :disabled="$route.meta.title != 'companyDetails'"
                            :content="
                              UpdateStatus == '3'
                                ? 'The offline report you downloaded is currently being produced.'
                                : 'The offline report you downloaded has been completed. Please download it from the updates ordered screen in your personal center'
                            "
                          >
                            <div
                              slot="reference"
                              id="c15095"
                              class="uUgrpts"
                              myData="测试"
                            >
                              {{
                                UpdateStatus == "3"
                                  ? "In production"
                                  : "Finished"
                              }}
                            </div>
                          </el-popover>
                        </div>
                      </template>
                    </gui_tab_item>
                  </div>
                  <!-- Report -->
                  <div
                    style="display: flex"
                    class="pb10 pt10 head_more_item"
                    v-if="
                      item.screenName == $t('Toolbar.Reporterror') &&
                      item.isShow == true &&
                      !config.reportError.isShow
                    "
                  >
                    <gui_tab_item
                      id="c6c5f5"
                      v-model="activeMenuId"
                      active_id="Report"
                      :isDisabel="
                        !config.reportError.isActive || !item.hasPrivilege
                      "
                      @input="clickMenu"
                    >
                      <template slot="icon">
                        <i
                          class="iconfont tollbar-con-list-item-icon icon-judan"
                        ></i>
                      </template>
                      <div
                        id="cdbd3a"
                        v-if="item.hasPrivilege"
                        class="uKD8C77"
                        myData="测试"
                      >
                        {{ $t("Toolbar.Reporterror") }}
                      </div>
                      <el-popover
                        v-else
                        placement="top-start"
                        :disabled="true"
                        width="200"
                        trigger="hover"
                      >
                        <div
                          slot="reference"
                          id="c15095"
                          class="uUgrpts uKD8C77"
                          myData="测试"
                        >
                          {{ $t("Toolbar.Reporterror") }}
                        </div>
                      </el-popover>
                    </gui_tab_item>
                  </div>
                  <!-- Risk Scanning -->
                  <div
                    style="display: flex"
                    class="pb10 pt10 head_more_item"
                    v-if="
                      item.screenName == 'Risk Scanning' &&
                      item.isShow == true &&
                      !config.riskScanning.isShow
                    "
                  >
                    <gui_tab_item
                      id="c6c5f5"
                      v-model="activeMenuId"
                      active_id="riskScanning"
                      :isDisabel="
                        !config.riskScanning.isActive || !item.hasPrivilege
                      "
                      @input="clickMenu"
                    >
                      <template slot="icon">
                        <i
                          class="iconfont tollbar-con-list-item-icon icon-saomiao"
                        ></i>
                      </template>
                      <div
                        id="cdbd3a"
                        v-if="item.hasPrivilege"
                        class="uKD8C77"
                        myData="测试"
                      >
                        {{ item.screenName }}
                      </div>
                      <el-popover
                        v-else
                        placement="top-start"
                        :disabled="true"
                        width="200"
                        trigger="hover"
                      >
                        <div
                          slot="reference"
                          id="c15095"
                          class="uUgrpts uKD8C77"
                          myData="测试"
                        >
                          {{ item.screenName }}
                        </div>
                      </el-popover>
                    </gui_tab_item>
                  </div>
                  <!--  Credit Assessment-->
                  <div
                    style="display: flex"
                    class="pb10 pt10 head_more_item"
                    v-if="
                      item.screenName == 'Credit Assessment' &&
                      item.isShow == true &&
                      !config.creditAssessment.isShow
                    "
                  >
                    <gui_tab_item
                      id="c6c5f5"
                      v-model="activeMenuId"
                      active_id="creditAssessment"
                      :isDisabel="
                        !config.creditAssessment.isActive || !item.hasPrivilege
                      "
                      @input="clickMenu"
                    >
                      <template slot="icon">
                        <i
                          class="iconfont tollbar-con-list-item-icon icon--fuwu-xianxing"
                        ></i>
                      </template>
                      <div
                        id="cdbd3a"
                        v-if="item.hasPrivilege"
                        class="uKD8C77"
                        myData="测试"
                      >
                        {{ item.screenName }}
                      </div>
                      <el-popover
                        v-else
                        placement="top-start"
                        :disabled="true"
                        width="200"
                        trigger="hover"
                      >
                        <div
                          slot="reference"
                          id="c15095"
                          class="uUgrpts uKD8C77"
                          myData="测试"
                        >
                          {{ item.screenName }}
                        </div>
                      </el-popover>
                    </gui_tab_item>
                  </div>
                  <!-- dataAnalysis -->
                  <div
                    style="display: flex"
                    class="pb10 pt10 head_more_item"
                    v-if="
                      item.screenName == 'Data Analysis' &&
                      item.isShow == true &&
                      !config.dataAnalysis.isShow
                    "
                  >
                    <gui_tab_item
                      id="c6c5f5"
                      v-model="activeMenuId"
                      active_id="dataAnalysis"
                      :isDisabel="
                        !config.dataAnalysis.isActive || !item.hasPrivilege
                      "
                      @input="clickMenu"
                    >
                      <template slot="icon">
                        <i
                          class="iconfont tollbar-con-list-item-icon icon-shujufenxi1"
                        ></i>
                      </template>
                      <div
                        id="cdbd3a"
                        v-if="item.hasPrivilege"
                        class="uKD8C77"
                        myData="测试"
                      >
                        {{ item.screenName }}
                      </div>
                      <el-popover
                        v-else
                        placement="top-start"
                        :disabled="true"
                        width="200"
                        trigger="hover"
                      >
                        <div
                          slot="reference"
                          id="c15095"
                          class="uUgrpts uKD8C77"
                          myData="测试"
                        >
                          {{ item.screenName }}
                        </div>
                      </el-popover>
                    </gui_tab_item>
                  </div>
                  <!-- customPortfolio -->
                  <div
                    style="display: flex"
                    class="pb10 pt10 head_more_item"
                    v-if="
                      item.screenName == 'New Portfolio' &&
                      item.isShow == true &&
                      !config.customPortfolio.isShow
                    "
                  >
                    <gui_tab_item
                      id="c6c5f5"
                      v-model="activeMenuId"
                      active_id="customPortfolio"
                      :isDisabel="
                        !config.customPortfolio.isActive || !item.hasPrivilege
                      "
                      @input="clickMenu"
                    >
                      <template slot="icon">
                        <i
                          class="iconfont tollbar-con-list-item-icon icon-touzizuhe"
                        ></i>
                      </template>
                      <div
                        id="cdbd3a"
                        v-if="item.hasPrivilege"
                        class="uKD8C77"
                        myData="测试"
                      >
                        {{ item.screenName }}
                      </div>
                      <el-popover
                        v-else
                        placement="top-start"
                        :disabled="true"
                        width="200"
                        trigger="hover"
                      >
                        <div
                          slot="reference"
                          id="c15095"
                          class="uUgrpts uKD8C77"
                          myData="测试"
                        >
                          {{ item.screenName }}
                        </div>
                      </el-popover>
                    </gui_tab_item>
                  </div>
                  <div
                    style="display: flex"
                    class="pb10 pt10 head_more_item"
                    v-if="
                      item.screenName == 'Print' &&
                      item.isShow == true &&
                      !config.print.isShow
                    "
                  >
                    <gui_tab_item
                      id="c6c5f5"
                      v-model="activeMenuId"
                      active_id="print"
                      :isDisabel="!config.print.isActive || !item.hasPrivilege"
                      @input="clickMenu"
                    >
                      <template slot="icon">
                        <i
                          class="iconfont tollbar-con-list-item-icon icon-dayin-dayinji"
                        ></i>
                      </template>
                      <div
                        id="cdbd3a"
                        v-if="item.hasPrivilege"
                        class="uKD8C77"
                        myData="测试"
                      >
                        {{ item.screenName }}
                      </div>
                      <el-popover
                        v-else
                        placement="top-start"
                        :disabled="true"
                        width="200"
                        trigger="hover"
                      >
                        <div
                          slot="reference"
                          id="c15095"
                          class="uUgrpts uKD8C77"
                          myData="测试"
                        >
                          {{ item.screenName }}
                        </div>
                      </el-popover>
                    </gui_tab_item>
                  </div>
                  <!-- Share -->
                  <div
                    style="display: flex"
                    class="pb10 pt10 head_more_item"
                    v-if="
                      item.screenName == $t('Toolbar.Share') &&
                      item.isShow == true &&
                      !config.share.isShow
                    "
                  >
                    <gui_tab_item
                      id="ccba1d"
                      v-model="activeMenuId"
                      active_id="Share"
                      :isDisabel="!config.share.isActive || !item.hasPrivilege"
                      @input="clickMenu"
                    >
                      <template slot="icon">
                        <i
                          class="iconfont tollbar-con-list-item-icon icon-gudong"
                        ></i>
                      </template>
                      <div id="c82736" myData="测试" class="uKD8C77">
                        {{ $t("Toolbar.Share") }}
                      </div>
                    </gui_tab_item>
                  </div>
                </div>
              </div>
            </el-dropdown-menu>
          </div>
        </el-dropdown>
      </gui_tab_item>
    </gui_tabs>
    <el-dialog
      :visible.sync="Share"
      center
      :close-on-click-modal="true"
      @close="closeDialog"
      custom-class="dialog_normalsuo"
      :append-to-body="true"
    >
      <div>
        <div class="detail_cont">
          <div class="flex_center margin-bottom20">
            <img
              class="dialog_img"
              src="../../assets/dialogIcoImg/shareIcon.png"
              alt=""
            />
          </div>
          <h3>{{ $t("ListofResults.Sharethisinformation") }}</h3>
          <h4 class="margin-top10 margin-bottom10">To</h4>
          <div class="website margin-bottom20">
            <el-input
              type="textarea"
              :rows="4"
              :placeholder="
                $t('ListofResults.Pleaseaddress') +
                '\n' +
                $t('ListofResults.Example') +
                ' : xxx@xxx.com; xxxx@xxxx.com'
              "
              :max="200"
              maxlength="200"
              show-word-limit
              v-model="textShare"
            >
            </el-input>
          </div>
          <h4 class="margin-bottom10">
            {{ $t("ListofResults.message") }}
          </h4>
          <div class="website margin-bottom20">
            <el-input
              type="textarea"
              :rows="4"
              :placeholder="$t('ListofResults.pleaseleaveamessage')"
              :max="200"
              maxlength="200"
              show-word-limit
              v-model="textShareMessage"
            >
            </el-input>
          </div>
          <h4 class="flex_center_start_box ShareBox">
            {{ $t("ListofResults.Include") }}
            <el-checkbox-group v-model="shareCheckList" class="margin-left20">
              <el-checkbox label="1"
                >{{ $t("ListofResults.thisaddress") }}
              </el-checkbox>
              <!-- <el-checkbox label="2">{{
                $t("ListofResults.CSIwebsite")
              }}</el-checkbox> -->
            </el-checkbox-group>
          </h4>
        </div>
      </div>
      <div class="flex_center margin-top30">
        <!-- <el-button
          class="btn_export btnbox btn_exporthui"
          @click="closeDialog"
          >{{ $t("MyAccount.Cancel") }}</el-button
        > -->
        <el-button
          class="btn_export btnbox"
          :class="textShare == '' ? 'btn_exporthui' : 'btn_export btnbox'"
          :disabled="textShare == ''"
          @click="SedingShare"
          >Send</el-button
        >
      </div>
    </el-dialog>
    <Custom
      :showReport="showReportIndex"
      :myDataMnegent="false"
      :CustomObj="CustomObj"
      @closeReportDialog="closeDialog3($event)"
    ></Custom>

    <!-- export dialog  -->
    <ExportDialog
      :showExportDialog="showExportDialog"
      @update:showExportDialog="closeExportDialog"
    ></ExportDialog>
  </div>
  <!--srcviewscompanycomponenttoolsvuehtmlEnd-->
</template>
<script>
// interfaceCode
//importStart
import {
  getEditqueryList,
  addEditqueryList,
  exportExcelDataForTrade,
} from "@/api/companyApi";
import {
  getCollectionList,
  addItems,
  showItems,
  creates,
  getqueryList,
  getqueryaddList,
  getqueryremoveList,
  sharingInformation,
} from "@/api/userApi";
import Custom from "../../components/CustomPortfolio/Custom.vue";
import gui_tab_item from "../../components/gui_tabs/gui_tab_item.vue";
import gui_tabs from "../../components/gui_tabs/gui_tabs.vue";
import ExportDialog from "./exportDialog.vue";
//importEnd

export default {
  name: "",

  props: {
    UpdateStatus: {
      type: Number,
      default: 0,
    },
    DownloadStatus: {
      type: Number,
      default: 0,
    },
    updateButtonActive: {
      type: Boolean,
      default: false,
    },
    companynameen: {
      type: String,
      default: "",
    },
    // 基础配置
    config: {
      type: Object,
      default: {
        Optimize: {
          isShow: true,
          isActive: true,
        },
        menu: {
          isShow: true,
          isActive: true,
        },
        filter: {
          isShow: true,
          isActive: true,
        },
        select: {
          isShow: true,
          isActive: true,
        },
        edit: {
          isShow: true,
          isActive: true,
        },
        sort: {
          isShow: true,
          isActive: true,
        },
        collect: {
          isShow: true,
          isActive: true,
        },
        saved: {
          isShow: true,
          isActive: true,
        },
        compare: {
          isShow: true,
          isActive: true,
        },
        export: {
          isShow: true,
          isActive: true,
        },
        download: {
          isShow: true,
          isActive: true,
        },
        update: {
          isShow: true,
          isActive: true,
        },
        reportError: {
          isShow: true,
          isActive: true,
        },
        riskScanning: {
          isShow: true,
          isActive: true,
        },
        creditAssessment: {
          isShow: true,
          isActive: true,
        },
        dataAnalysis: {
          isShow: true,
          isActive: true,
        },
        customPortfolio: {
          isShow: true,
          isActive: true,
        },
        print: {
          isShow: true,
          isActive: true,
        },
        share: {
          isShow: true,
          isActive: true,
        },
      },
    },
  },
  created() {},
  mounted() {},

  watch: {
    "$i18n.locale": {
      handler(newVal, oldVal) {
        this.getqueryList();
        this.getEditkList();
      },
      deep: true, // 深度监听，可以监听对象内部属性的变化
      immediate: true, // 立即执行一次handler函数，即使columns没有变化
    },
    "$store.state.app.SearchagAin": {
      handler(newVal, oldVal) {
        // 在这里处理columns属性的变化
        if (newVal) {
          this.activeSavedId = "";
        }
      },

      deep: true, // 深度监听，可以监听对象内部属性的变化
      immediate: true, // 立即执行一次handler函数，即使columns没有变化
    },
    "$store.state.app.collectList": {
      handler(newVal, oldVal) {
        // 在这里处理columns属性的变化
        if (newVal) {
          if (newVal.length == 0) {
            this.checkList = [];
          }
        }
      },

      deep: true, // 深度监听，可以监听对象内部属性的变化
      immediate: true, // 立即执行一次handler函数，即使columns没有变化
    },
    token: {
      handler(newVal, oldVal) {
        if (newVal) {
          // this.openMenu = ['2', '3', '4', '5', '6', '7', '8'];
        } else {
        }
      },
      immediate: true,
    },
    updateButtonActive: {
      handler(newVal, oldVal) {
        if (newVal) {
        } else {
        }
      },
      immediate: true,
    },
    companynameen: {
      handler(newVal) {
        this.localExportFileName =
          newVal + "_" + this.getCurrentDate() + ".xlsx";
      },
      immediate: true,
    },
  },
  components: {
    // gui_tabs start
    gui_tabs,
    gui_tab_item,
    Custom,
    ExportDialog,
    // gui_tab_item end
  },
  data() {
    return {
      textShare: "",
      textShareMessage: "",
      shareCheckList: ["1"],
      CustomObj: {
        groupTask: "",
        executorName: "",
        portfolioName: "",
        userName: "",
        id: "",
      },
      showReportIndex: false,
      background: "background-color:",
      website: "https://csibizsearch.com",
      CollectAdd: "",
      CollectShow: false,
      checkList: [],

      Editoptions: [],
      DetailsForm: [],
      // activeMenuId
      activeMenuId: "all",
      // isOpenSelect
      isOpenSelect: false,
      // isOpenSlct
      isOpenSlct: false,
      Share: false,
      // 默认列
      defaultColumns: [],
      // 表格列表数据
      columns: [],
      // cascader6Value
      cascader6Value: [],
      //
      sortList: "",
      // rowsSlct
      rowsSlct: [],
      // 素选id
      activeFavoritesId: "",
      // 收藏列表
      favoritesList: [],
      // 素选id
      activeSavedId: "",
      // 收藏列表
      savedList: [],
      SortArrlist: [],
      queryList: [],
      UPdateshow: false,
      UPdatetype: "2",
      token: localStorage.getItem("token"),
      // srcviewscompanycomponenttoolsvueDataEnd
      showExportDialog: false,
      localExportFileName: "",
    };
  },
  updated() {
    window.addEventListener("setItem", () => {
      this.token = localStorage.getItem("token");
    });
  },
  destroyed() {
    window.removeEventListener("setItem", () => {
      this.token = localStorage.getItem("token");
    });
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
  },
  methods: {
    // 添加分组
    closeDialog3(value) {
      this.showReportIndex = value;
    },
    // 分享确定

    //跳转扫描
    linkToRiskScanning() {
      let routeData = this.$router.resolve({
        path: "/riskScanning/index",
      });
      window.open(routeData.href, "_blank");
    },
    SedingShare() {
      let Updatelis = [];
      this.$store.state.app.changeList.map((item) => {
        Updatelis.push(item.aaa_id);
      });

      let params = {
        message: this.textShareMessage,
        toEmail: this.textShare.split(";"),
        sourceEmail: JSON.parse(localStorage.getItem("userInfo"))?.userInfo
          ?.email,
        type: this.shareCheckList,
        aaaIds: Updatelis,
      };
      sharingInformation(params).then((res) => {
        if (res.code == 200) {
          this.$message({
            message: res.msg,
            type: "success",
          });
        } else {
          this.$message({
            message: res.msg,
            type: "error",
          });
        }
        this.Share = false;
      });
    },
    powermethod(vaue) {
      if (!vaue.hasPrivilege && this.token) {
        this.$bus.$emit("show-permission-dialog", "您没有权限访问该功能！");
      }
    },
    addTool(item) {
      let obj = this.queryList.find((item2) => item2.id == item.id);
      if (item.isShow == false) {
        item.isShow = true;
        getqueryaddList({
          moduleId: item.moduleId,
        }).then((res) => {});
      }
    }, // taggleFlolwing
    DeelteTool(item) {
      if (item.isShow == true) {
        item.isShow = false;
        getqueryremoveList({
          moduleId: item.moduleId,
        }).then((res) => {});
      }
    },
    getqueryList() {
      getqueryList().then((res) => {
        if (res.code == 200) {
          this.queryList = res.data;
        }
      });
    },
    getCurrentDate() {
      const date = new Date();
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}${month}${day}`;
    },
    clickExport() {
      if (this.$route.meta.title == "TradeDetails") {
        let params = {
          aaaid: this.$route.query.id3a,
          menuIds: [1136],
        };
        exportExcelDataForTrade(params).then((res) => {
          if (res.status === 200) {
            this.$message({
              type: "success",
            });

            const blob = new Blob([res.data], { type: "application/excel" });

            const href = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = href;
            link.download = this.localExportFileName;
            link.click();

            // 释放URL对象
            setTimeout(() => {
              URL.revokeObjectURL(href);
            }, 100);
          } else {
            this.$message({
              type: "error",
            });
          }
        });
      } else if (
        this.$route.meta.title == "companyListSearch" ||
        this.$route.name == "riskNoParams"
      ) {
        this.showExportDialog = true;
      }
    },
    closeExportDialog(value) {
      this.showExportDialog = value;
    },
    // 调用浏览器的复制操作
    WebAdd() {
      const textarea = document.createElement("textarea");
      textarea.value = this.website;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy"); //
    },
    closeDialog() {
      this.Share = false;
    },
    CheckSort(val) {
      this.clickMenu("Sort", this.sortList);
    },
    AddCollect() {
      if (this.CollectAdd == "") {
      } else {
        creates({ collectionName: this.CollectAdd }).then((res) => {
          if (res.code == 200) {
            this.CollectShow = false;
            this.$message({
              message: res.msg,
              center: true,
              type: "success",
            });
            this.getEditkList();
          }
        });
      }
    },
    ChangeSave(id) {
      this.clickMenu("Saved", id);
      this.$store.dispatch("app/SetarchagAin", false);
    },
    getEditkList() {
      getEditqueryList().then((res) => {
        if (res.code == 200) {
          this.Editoptions = res.data.map((item) => {
            return {
              ...item, // 保留原始对象的其他属性
              children: item.children
                ? item.children.map((ite) => {
                    const { children, ...rest } = ite; // 解构出子节点的 children 属性
                    return rest; // 返回不包含 children 的新对象
                  })
                : [], // 如果没有子节点，返回空数组
            };
          });
          // SortArrlist
          let sortArr = [];
          this.Editoptions.map((item) => {
            item.children.map((ite) => {
              sortArr.push(ite);
            });
          });
          this.sort_listOptions[0].children = [];
          this.sort_listOptions[1].children = [];
          sortArr.map((item) => {
            if (item.sortName != "") {
              this.sort_listOptions[0].children.push({
                value: item.sortName,
                label: item.screenName,
              });
              this.sort_listOptions[1].children.push({
                value: item.sortName,
                label: item.screenName,
              });
            }
          });

          let arr = [];
          this.Editoptions.map((item) => {
            item.children.map((ite) => {
              if (
                ite.userEditable &&
                !this.cascader6Value.includes(ite.columnName)
              ) {
                this.cascader6Value.push(ite.columnName);
              }
              if (this.cascader6Value.includes(ite.columnName)) {
                arr.push(ite);
              }
            });
          });
          this.Editoptions.forEach((ops) => {
            if (ops.moduleId == 360 && !ops.hasPrivilege) {
              ops.disabled = true;
            } else {
              ops.disabled = false;
            }
          });
          this.$store.dispatch("app/seColumnsArr", arr);
          this.clickMenu("edit", this.cascader6Value);
          // this.changeColumn(this.cascader6Value)
        } else {
          this.Editoptions = [];
        }
      });
      if (this.token) {
        getCollectionList().then((collect) => {
          if (collect.code == 200) {
            this.favoritesList = collect.data;
          } else {
            this.favoritesList = [];
          }
        });
      }
    },

    // 点击菜单
    clickMenu(name, data) {
      if (name == "Share") {
        this.Share = true;
      }
      if (name == "riskScanning") {
        this.linkToRiskScanning();
      }
      if (name == "customPortfolio") {
        this.showReportIndex = true;
      }
      if (name == "dataAnalysis") {
        let Updatelis = [];
        this.$store.state.app.changeList.map((item) => {
          Updatelis.push(item.aaa_id);
        });
        let routeData = this.$router.resolve({
          path: "/account/industryAnalysis",
          query: { aaaids: Updatelis.join("@@") },
        });
        window.open(routeData.href, "_blank");
      }
      this.$emit("clickMenu", name, data);
    },
    clickMenuUpdate() {
      this.$emit("clickMenu", "Update", null);
    },
    clickAll(name, data) {
      this.$emit("clickMenu", name, data);
    },
    CollectCheckBook() {
      this.$store.dispatch("app/setcollectList", this.checkList);
    },
    // changeMenu
    changeMenu(isMenu) {
      this.$refs.contentView.changeMenu(isMenu);
      this.isShowMenu = this.$refs.contentView.isMenu;
    }, // openMenu
    // 级联多选
    changeColumn(cascader6Value) {
      let arr = [];
      let arrmoduleId = [];
      this.Editoptions.map((item) => {
        item.children.map((ite) => {
          if (cascader6Value.includes(ite.columnName)) {
            arr.push(ite);
            arrmoduleId.push(ite.moduleId);
          }
        });
      });

      addEditqueryList({
        moduleIds: arrmoduleId,
      }).then((res) => {
        if (res.code == 200) {
          // this.getEditkList()
        }
      });
      this.$store.dispatch("app/seColumnsArr", arr);
      this.clickMenu("edit", cascader6Value);
    }, // 所选的值回调
    setRowsSlct(rows) {
      this.rowsSlct = rows;
    },
  },
  computed: {
    sort_listOptions() {
      return [
        {
          value: "ASC",
          label: this.$t("Toolbar.ascending"),
          disabled: false,
          children: [],
        },
        {
          value: "DESC",
          label: this.$t("Toolbar.descending"),
          disabled: false,

          children: [],
        },
      ];
    },
  },
};
</script>
<style scoped>
.riskScanningColor {
  background: #334b35 !important;
}
.uJeKUqr {
  width: 100%;
}

.usRlj2Q {
  vertical-align: middle;
}

.uskVhXw {
  height: 36px;
  padding: 0 10px;
  color: rgb(252, 252, 252);
  border-radius: 10px;
}
.select_tab {
  line-height: 34px;
}
.u79e9d {
  height: 1.42rem;
}

.u39929 {
  color: rgb(255, 255, 255);
  margin-right: 0.6rem;
  color: inherit;
}

.uOLnMLV {
  display: flex;
  align-items: center;
}

.ua4c9f {
  height: 4em;
  margin-right: 0.5rem;
  margin-bottom: -2rem;
  margin-top: -2rem;
  border-right-style: solid;
  border-right-width: 0.07142857142857142rem;
  border-right-color: rgb(255, 255, 255);
}

.ujOvfa4 {
  margin-right: -0.7rem;
}

.udVmvz8 {
  fill: #fff !important;
}

.u7d9e0 {
  display: flex;
  align-items: center;
  display: flex;
}

.u6jM1KJ {
  margin-right: 0.5rem;
}

.uhwg9v2 {
  margin-right: 0.35714285714285715rem;
}

.u6aa68 {
  margin-left: 1.4285714285714286rem;
  background-color: #8497ab !important;
  cursor: not-allowed;
  color: #fff;
}

.u2c700 {
  color: #fff;
}

.u27d59 {
  flex: auto;
}

.uupMxrD {
  display: none;
  margin-left: 5px;
  margin-left: 5px;
}

.u994i9a {
  color: inherit;
  width: max-content;
  color: inherit;
}

.u5c5c7 {
  flex-direction: column;
}

.u324ce {
  display: flex;
  align-items: center;
}

.unrH9VJ {
  margin-right: 6px;
}

.u606de {
  display: flex;
  align-items: center;
}

.ucc8d2 {
  font-size: 16px;
}
.uoCrWss path {
  fill: hsl(0, 0%, 100%) !important;
}

.colDropDown /deep/ .checkBoxHover :hover {
  background-color: #f5f5f5;
}
.colDropDown /deep/ .checkBoxHover :hover .el-checkbox__label {
  color: rgba(18, 144, 201, 1);
}
body:has(.leads_layout)
  .colDropDown
  /deep/
  .checkBoxHover
  :hover
  .el-checkbox__label {
  color: #8e86dd;
}
.svg_update path {
  fill: rgba(18, 144, 201, 1);
}

.ukfmqKe path {
  fill: black;
}
.colDropDown {
  width: 280px;
}
.colDropDown .el-checkbox-group {
  padding-top: 3px;
  padding-bottom: 10px;
}
.colDropDown .el-checkbox-group .elcheckbook {
  display: flex;
  align-items: center;
  justify-content: start;
  height: 40px;
  padding-left: 20px;
  margin-right: 0;
  gap: 10px;
  width: 100%;
}
.colDropDown /deep/ .el-checkbox__label {
  padding-left: 0;
  font-size: 16px;
}

.CollectBottom {
  padding: 20px 20px 12px 20px;
  border-top: 1px solid #dddddd;
  font-size: 16px;
  display: flex;
  align-items: center;
  color: #1a2332;
}

.CollecInput {
  padding: 0 20px 20px 20px;
}

.CollecInput /deep/ .el-input-group--append .el-input__inner {
  border-right: none !important;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  border: 1px solid #cccccc;
  line-height: 40px;
}
.CollecInput /deep/ .el-input-group__append {
  background: #1290c9;
  border-radius: 10px;
  color: #fff;
  position: relative;
  left: -6px;
  width: 80px;
  height: 40px;
}
.CollecInput /deep/ .el-input-group__append .el-button {
  width: 80px;
  min-width: 80px;
  height: 40px;
  padding: 15px 0px;
  text-align: center;
}
body:has(.leads_layout) .CollecInput /deep/ .el-input-group__append {
  background: #8e86dd;
}

.uvHkMZZ,
#caa1e7 {
  font-size: 16px;
}

.checkbox {
  height: 28.571428571428573rem;
  overflow-y: auto;
}

.detail_cont h4 {
  font-size: 18px;
  line-height: 30px;
  color: #1a2332;
}
.dialog_img {
  width: 80px;
  height: 64px;
}

::v-deep .el-textarea__inner {
  height: 180px;
  padding: 10px 14px;
  border-radius: 10px;
  font-size: 18px;
}

.u1aaaf {
  display: flex;
  align-items: center;
  height: 2.4285714285714284rem;
  margin-right: 1rem;
  padding-left: 1.0714285714285714rem;
  padding-right: 1.0714285714285714rem;
  padding-top: 0.8428571428571429rem;
  padding-bottom: 0.6428571428571429rem;
  margin-bottom: 1rem;
  background: #f5f5f5;
  border-radius: 0.2857142857142857rem;
}

.ud0e75 {
  padding-bottom: 1rem;
}

.u8d45c {
  color: #1290c9;
  font-size: 1.1428571428571428rem;
  margin-bottom: 0.7142857142857143rem;
  font-weight: normal;
  text-align: left;
  line-height: 0.8571428571428571rem;
  font-style: normal;
  margin-top: 0.42857142857142855rem;
}

.u47dc6 {
  display: flex;
  flex-wrap: wrap;
}

.u4646c {
  margin-right: 0.21428571428571427rem;
}

.ukBgk9n {
  margin-right: 1.4285714285714286rem;
  color: #1a2332;
  font-size: 1.1428571428571428rem;
  text-align: left;
  line-height: 0.8571428571428571rem;
  font-style: normal;
  margin-bottom: 2px;
}

.ufd6a8 {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 1.4285714285714286rem;
  height: 1.4285714285714286rem;
  border-bottom-left-radius: 100rem;
  border-top-left-radius: 100rem;
  border-top-right-radius: 100rem;
  border-bottom-right-radius: 100rem;
  margin-left: 0.5rem;
  background: #ffffff;
}

.u47dc6 .active {
  border: 0.07142857142857142rem solid #1290c9;
}

.u47dc6 .active {
  border: 0.07142857142857142rem solid #1290c9;
}

.u807e8 .active {
  color: rgba(18, 144, 201, 1);
}

.u606de .active {
  color: rgba(18, 144, 201, 1);
  fill: #1290c9;
}

#gd5a26 {
  background: #ffffff;
  padding-right: 20px;
}

#c2da93 {
  margin-left: 30px !important;
}

.el-checkbox__input.is-checked + .el-checkbox__label {
  color: #1290c9;
}

.el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #1290c9;
  border-color: #1290c9;
}

.btnbox {
  display: flex;
  width: 210px;
  height: 50px;
  line-height: 50px;
  border-radius: 10px;
  color: #ffffff;
  font-size: 18px;
  padding: 0 !important;
  align-items: center;
  justify-content: center;
}
.is-disabled.btn_exporthui {
  color: #8497ab !important;
}
.btn_update {
  position: relative;
  width: 120px;
  height: 36px;
  line-height: 34px;
  border-radius: 18px;
  border: 1px solid #1290c9;
  color: #1290c9;
  font-size: 16px;
  padding: 0 !important;
  margin-left: 30px;
  box-shadow: 0 0 10px rgba(18, 144, 201, 0.4);
}
.btn_update /deep/ span {
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "Arial Bold";
}
.btn_update::before,
.btn_update::after {
  position: absolute;
  content: "";
  display: block;
  width: 140%;
  height: 100%;
  left: -20%;
  background-repeat: no-repeat;
}
.btn_update::before {
  top: -75%;
  background-image: radial-gradient(circle, #f9722c 20%, transparent 20%),
    radial-gradient(circle, transparent 20%, #f9722c 20%, transparent 30%),
    radial-gradient(circle, #f9722c 20%, transparent 20%),
    radial-gradient(circle, #f9722c 20%, transparent 20%),
    radial-gradient(circle, transparent 10%, #f9722c 15%, transparent 20%),
    radial-gradient(circle, #f9722c 20%, transparent 20%),
    radial-gradient(circle, #f9722c 20%, transparent 20%),
    radial-gradient(circle, #f9722c 20%, transparent 20%),
    radial-gradient(circle, #f9722c 20%, transparent 20%);
  background-size: 20% 20%, 30% 30%, 25% 25%, 30% 30%, 28% 28%, 20% 20%, 25% 25%,
    20% 20%, 28% 28%;
  animation: topBubbles ease-in-out 0.75s infinite;
}
.btn_update::after {
  bottom: -75%;
  background-image: radial-gradient(circle, #f9722c 20%, transparent 20%),
    radial-gradient(circle, #f9722c 20%, transparent 20%),
    radial-gradient(circle, transparent 10%, #f9722c 15%, transparent 20%),
    radial-gradient(circle, #f9722c 20%, transparent 20%),
    radial-gradient(circle, #f9722c 20%, transparent 20%),
    radial-gradient(circle, #f9722c 20%, transparent 20%),
    radial-gradient(circle, #f9722c 20%, transparent 20%);
  background-size: 25% 25%, 30% 30%, 28% 28%, 30% 30%, 25% 25%, 20% 20%, 30% 30%;
  animation: bottomBubbles ease-in-out 0.75s infinite;
}

.uKD8C77,
.conten {
  font-size: 16px;
}
.u606de .uKD8C77 {
  color: #1a2332;
}
.el-dropdown-menu /deep/ #c5c5cb :hover .uKD8C77 {
  color: rgba(18, 144, 201, 1);
}
body:has(.leads_layout) .colDropDown /deep/ .is-checked .el-checkbox__label,
body:has(.leads_layout) .el-dropdown-menu /deep/ #c5c5cb :hover .uKD8C77 {
  color: #8e86dd;
}
.tollbar-con-filter {
  display: flex;
  align-items: center;
}
.tollbar-con-filter-icon {
  width: 20px;
  height: 15px;
  margin-right: 20px;
  cursor: pointer;
}
.tollbar-con-filter-btn {
  width: 120px;
  height: 36px;
  padding: 0;
  border-radius: 20px;
  overflow: hidden;
}
.usRlj2QRisk {
  background: #8e86dd !important;
}
.tollbar-con-filter-btn {
  background: #1290c9;
}
.tollbar-con-filter-btn.is-disabled {
  background: #eeeeee !important;
}
.tollbar-con-filter-btn >>> span {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: #ffffff;
}
.tollbar-con-filter-btn >>> i {
  margin-right: 6px;
  font-size: 12px;
  align-items: center;
}
.tollbar-con-filter-btn.is-disabled >>> span {
  color: #999999;
}
.usRlj2QTrade {
  background-color: #009ea7 !important;
}
.tollbar-con-list-item-icon {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  width: 20px;
  margin-right: 5px;
  font-size: 18px;
}
.tollbar-con-list-item-icon.icon-dayin-dayinji,
.tollbar-con-list-item-icon.icon--fuwu-xianxing,
.tollbar-con-list-item-icon.icon-xuanze,
.tollbar-con-list-item-icon.icon-gudong {
  font-size: 20px;
}
.tollbar-con-list-item-icon.icon-shoucang1,
.tollbar-con-list-item-icon.icon-saomiao,
.tollbar-con-list-item-icon.icon-filter,
.tollbar-con-list-item-icon.icon-xiazai {
  font-size: 22px;
}
.tollbar-con-list-item-icon.icon-judan,
.tollbar-con-list-item-icon.icon-bianji1 {
  font-size: 24px;
}
.tollbar-con-list-item-icon.icon-gengduo2 {
  font-size: 26px;
}
.tollbar-con-list-item-icon.icon-xiazai,
.tollbar-con-list-item-icon.icon-filter,
.tollbar-con-list-item-icon.icon-bianji1,
.tollbar-con-list-item-icon.icon-shoucang1 {
  align-items: self-end;
}
.tollbar-con-list-item-icon.icon-judan,
.tollbar-con-list-item-icon.icon-saomiao {
  height: 22px;
  align-items: center;
}

.head_more_item .uGuqXzB {
  line-height: 20px;
}
.more_list .tollbar-con-list-item-icon {
  align-items: center;
}
@media (max-width: 1920px) {
  .uGuqXzB {
    margin-left: 20px;
  }
  .tollbar-con-filter-btn {
    width: 80px;
    min-width: 80px;
    height: 24px;
    border-radius: 14px;
  }
  .tollbar-con-filter-btn >>> span {
    font-size: 14px;
  }
  .tollbar-con-filter-btn >>> i {
    font-size: 10px;
  }
  .tollbar-con-list-item-icon {
    width: 16px;
    height: 14px;
    margin-right: 3px;
    font-size: 13px;
  }
  .tollbar-con-list-item-icon.icon-dayin-dayinji,
  .tollbar-con-list-item-icon.icon--fuwu-xianxing,
  .tollbar-con-list-item-icon.icon-xuanze,
  .tollbar-con-list-item-icon.icon-gudong,
  .tollbar-con-list-item-icon.icon-shoucang1,
  .tollbar-con-list-item-icon.icon-saomiao,
  .tollbar-con-list-item-icon.icon-filter,
  .tollbar-con-list-item-icon.icon-xiazai {
    font-size: 16px;
  }
  .tollbar-con-list-item-icon.icon-gengduo2 {
    font-size: 18px;
  }
  .tollbar-con-list-item-icon.icon-judan,
  .tollbar-con-list-item-icon.icon-bianji1 {
    font-size: 18px;
  }
  .tollbar-con-list-item-icon.icon-xiazai,
  .tollbar-con-list-item-icon.icon-filter,
  .tollbar-con-list-item-icon.icon-bianji1,
  .tollbar-con-list-item-icon.icon-shoucang1,
  .tollbar-con-list-item-icon.icon-judan,
  .tollbar-con-list-item-icon.icon-saomiao {
    align-items: center;
  }
  .tollbar-con-list-item-icon.update-icon {
    position: relative;
    top: 1px;
    align-items: center;
    font-weight: bold;
  }
  .uKD8C77,
  .conten {
    font-size: 14px;
  }
  #c4d1dc {
    margin-left: 20px;
  }
  #gd5a26 {
    padding-right: 10px;
  }
  .el-dropdown-menu {
    padding: 0;
  }
  .colDropDown {
    width: 260px;
  }
  .colDropDown .el-checkbox-group {
    padding-top: 8px;
    padding-bottom: 8px;
  }
  .colDropDown .el-checkbox-group .elcheckbook {
    height: 34px;
    padding-left: 15px;
    gap: 8px;
  }

  .colDropDown /deep/ .el-checkbox__label {
    font-size: 14px;
  }
  .CollectBottom {
    padding: 10px 15px;
    font-size: 14px !important;
  }
  .CollectBottom /deep/ .icon {
    width: 16px;
    height: 16px;
  }
  .CollecInput {
    padding: 0 15px 15px 15px;
  }

  .CollecInput /deep/ .el-input-group--append .el-input__inner {
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
    line-height: 32px;
  }

  .CollecInput /deep/ .el-input-group__append {
    border-radius: 8px;
    left: -4px;
    width: 64px;
    height: 32px;
  }
  .CollecInput /deep/ .el-input-group__append .el-button {
    width: 64px;
    min-width: 64px;
    height: 32px;
    padding: 9px 0px;
  }
  #caa1e7,
  #c5f4d9,
  #ce9d28,
  #cbe032,
  #c214bd {
    font-size: 14px;
  }
  #c2da93 {
    margin-left: 20px !important;
  }
  .uskVhXw {
    height: 24px;
    padding: 0 7px;
    border-radius: 7px;
  }
  .select_tab {
    line-height: 22px;
  }
  .detail_cont h4 {
    font-size: 16px;
    line-height: 22px;
  }
  .dialog_img {
    width: 60px;
    height: 48px;
  }
  ::v-deep .el-textarea__inner {
    height: 135px;
    padding: 10px;
    font-size: 16px;
  }
  .btnbox {
    width: 160px;
    height: 36px;
    border-radius: 8px;
    font-size: 16px;
    line-height: 16px;
  }
  .btn_update {
    width: 80px;
    height: 24px;
    line-height: 22px;
    border-radius: 12px;
    font-size: 14px;
    padding: 0 !important;
    margin-left: 20px;
  }
}
@media screen and (max-width: 1439px) {
  .uKD8C77,
  .conten {
    font-size: 12px;
  }
  #c4d1dc {
    margin-left: 12px;
  }
  #gd5a26 {
    padding-right: 5px;
  }
  .uGuqXzB {
    margin-left: 12px;
  }
  .colDropDown {
    width: 240px;
  }
  .colDropDown .el-checkbox-group {
    padding-top: 6px;
    padding-bottom: 6px;
  }
  .colDropDown .el-checkbox-group .elcheckbook {
    height: 32px;
    padding-left: 12px;
    gap: 6px;
  }
  .CollectBottom {
    padding: 8px 12px;
  }
  .CollecInput {
    padding: 0 12px 12px 12px;
  }

  .CollecInput /deep/ .el-input-group--append .el-input__inner {
    border-top-left-radius: 6px;
    border-bottom-left-radius: 6px;
    line-height: 28px;
  }

  .CollecInput /deep/ .el-input-group__append {
    border-radius: 6px;
    width: 56px;
    height: 28px;
  }
  .CollecInput /deep/ .el-input-group__append .el-button {
    width: 56px;
    min-width: 56px;
    height: 28px;
    padding: 7px 0px;
  }
  #c2da93 {
    margin-left: 15px !important;
  }
  .uskVhXw {
    height: 24px;
    padding: 0 6px;
    border-radius: 6px;
  }
  .detail_cont h4 {
    line-height: 20px;
  }
  .dialog_img {
    width: 54px;
    height: 42px;
  }
  ::v-deep .el-textarea__inner {
    height: 120px;
  }
  .btnbox {
    width: 140px;
    height: 32px;
    border-radius: 6px;
    font-size: 14px;
    line-height: 14px;
  }
}

@keyframes topBubbles {
  0% {
    background-position: 5% 90%, 10% 90%, 10% 90%, 15% 90%, 25% 90%, 25% 90%,
      40% 90%, 55% 90%, 70% 90%;
  }
  50% {
    background-position: 0% 80%, 0% 20%, 10% 40%, 20% 0%, 30% 30%, 22% 50%,
      50% 50%, 65% 20%, 90% 30%;
  }
  100% {
    background-position: 0% 70%, 0% 10%, 10% 30%, 20% -10%, 30% 20%, 22% 40%,
      50% 40%, 65% 10%, 90% 20%;
    background-size: 0% 0%, 0% 0%, 0% 0%, 0% 0%, 0% 0%, 0% 0%;
  }
}
@keyframes bottomBubbles {
  0% {
    background-position: 10% -10%, 30% 10%, 55% -10%, 70% -10%, 85% -10%,
      70% -10%, 70% 0%;
  }
  50% {
    background-position: 0% 80%, 20% 80%, 45% 60%, 60% 100%, 75% 70%, 95% 60%,
      105% 0%;
  }
  100% {
    background-position: 0% 90%, 20% 90%, 45% 70%, 60% 110%, 75% 80%, 95% 70%,
      110% 10%;
    background-size: 0% 0%, 0% 0%, 0% 0%, 0% 0%, 0% 0%, 0% 0%;
  }
}
</style>
